module.exports = __webpack_public_path__ + "img/3.5618a9d5.png";